import HubbleImage from "~/widgets/hubble_image";

type DenominationsHeaderProps = {
  brandTitle: string;
  brandLogoUrl: string;
};

export function DenominationsHeader(props: DenominationsHeaderProps) {
  return (
    <div class="inline-flex items-start justify-between self-stretch px-4 lg:px-6">
      <div class="inline-flex flex-col items-start justify-start">
        <div class=" text-h5 font-semibold leading-relaxed text-textDark lg:text-h3">
          Gift Card value
        </div>
        <div class="text-medium text-baseSecondaryMedium">
          Your shopping amount
        </div>
      </div>
      <div class="relative h-11 w-11 rounded-[50%] lg:h-[52px] lg:w-[52px]">
        <HubbleImage
          src={props.brandLogoUrl}
          class="h-full w-full rounded-full border border-neutral-200 object-cover darkTheme:border-baseTertiaryDark "
          alt={`${props.brandTitle}'s logo url`}
        />
      </div>
    </div>
  );
}
